var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowsMove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.47 5.53a.75.75 0 0 1 0-1.06l3-3a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1-1.06 1.06l-1.72-1.72V8a.75.75 0 0 1-1.5 0V3.81L9.53 5.53a.75.75 0 0 1-1.06 0Zm-4 2.94a.75.75 0 0 1 1.06 1.06l-1.72 1.72H8a.75.75 0 0 1 0 1.5H3.81l1.72 1.72a.75.75 0 1 1-1.06 1.06l-3-3a.75.75 0 0 1 0-1.06l3-3Zm15.06 0a.75.75 0 1 0-1.06 1.06l1.72 1.72H16a.75.75 0 0 0 0 1.5h4.19l-1.72 1.72a.75.75 0 1 0 1.06 1.06l3-3a.75.75 0 0 0 0-1.06l-3-3ZM8.47 19.53a.75.75 0 1 1 1.06-1.06l1.72 1.72V16a.75.75 0 0 1 1.5 0v4.19l1.72-1.72a.75.75 0 1 1 1.06 1.06l-3 3a.75.75 0 0 1-1.06 0l-3-3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsMove);
export default __webpack_public_path__ + "static/media/arrows-move.9be40dae2f6ca14354c926bf8d3a136c.svg";
export { ForwardRef as ReactComponent };